import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  LineChart,
  Line as RechartsLine,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';

const Line = ({ data, options }) => {
  // Transform Chart.js data format to Recharts format
  // Chart.js format: { labels: [...], datasets: [{label, data, ...}, ...] }
  // Recharts format: [{ name: 'x', value1: y1, value2: y2, ... }, ...]

  const transformData = () => {
    if (!data || !data.labels || !data.datasets) {
      return [];
    }

    return data.labels.map((label, index) => {
      const dataPoint = { name: label };
      data.datasets.forEach((dataset) => {
        const key = dataset.label || 'value';
        dataPoint[key] = dataset.data[index];
      });
      return dataPoint;
    });
  };

  const chartData = transformData();

  // Extract dataset keys for rendering lines
  const dataKeys = data?.datasets?.map(ds => ds.label || 'value') || ['value'];

  // Define color palette with gray tones
  const colors = ['#374151', '#6b7280', '#9ca3af', '#d1d5db'];

  return (
    <div className="w-full h-[300px]">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" fontSize={12} />
          <YAxis fontSize={12} />
          <Tooltip />
          {dataKeys.length > 1 && <Legend />}
          {dataKeys.map((key, index) => (
            <RechartsLine
              key={key}
              type="monotone"
              dataKey={key}
              stroke={colors[index % colors.length]}
              strokeWidth={2}
              dot={{ r: 3 }}
              activeDot={{ r: 5 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

Line.propTypes = {
  data: PropTypes.object.isRequired,
  options: PropTypes.object
};

export default Line;
